<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap class="mt-3 text-center">
        <v-flex xs12>
          <v-form v-model="valid" @submit.prevent="validateAuditor">
            <v-container>
              <v-layout text-xs-center wrap class="mt-3">
                <v-flex xs12>
                  <h4>Please enter your Auditor ID:</h4>
                  <v-text-field v-model.trim="auditorId" label="Auditor ID" required></v-text-field>
                  <v-btn
                    type="button"
                    @click="validateAuditor"
                    :disabled="auditorId.length === 0"
                  >Submit</v-btn>

                  <v-snackbar
                    v-model="failureSnackbar"
                    color="failure"
                    :multi-line="true"
                    :timeout="10000"
                    :vertical="true"
                  >
                    Invalid Auditor ID!
                    <v-btn dark text @click="failureSnackbar = false"></v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  name: "Login",
  data: () => ({
    valid: false,
    auditorId: "",
    failureSnackbar: false
  }),
  mounted() {},
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    },
    getAuditEvent() {
      return this.$store.getters.getAuditEvent;
    }
  },
  created() {
    this.checkIfLoggedIn();
  },
  methods: {
    ...mapActions({
      setAuditEvent: "setAuditEvent",
      setAuditorID: "setAuditorID"
    }),
    validateAuditor() {
      if (this.auditorId.length > 0) {
        let config = {
          url: `${this.getBaseUrl}/auditEvent/getAuditEventbyAuditorID/${this.auditorId}`,
          method: "GET"
        };
        axios(config)
          .then(response => {
            if (response.status === 200) {
              if (response.data.auditorID.length > 0) {
                this.setAuditEvent(response.data);
                this.setAuditorID(this.auditorId);
                this.$router.push("/upload");
              } else {
                this.failureSnackbar = true;
                this.setAuditEvent(null);
                this.setAuditorID(null);
              }
            } else {
              this.failureSnackbar = true;
              this.setAuditEvent(null);
              this.setAuditorID(null);
            }
          })
          .catch(err => {
            // eslint-disable-next-line
            this.failureSnackbar = true;
            console.log(err);
            this.setAuditEvent(null);
            this.setAuditorID(null);
          });
        //
      } else {
        // todo handle error better
        alert("You didn't enter a Auditor ID");
      }
    },
    checkIfLoggedIn() {
      if (this.getAuditEvent !== null) {
        this.$router.push("/upload");
      }
    }
  }
};
</script>

<style scoped>
</style>


